import type { Ref } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { getHardwareHistory } from '~/services-v2/installation-api/installation-api'

export default function useHardwareHistory(projectId: Ref<string>) {
  const queryKey = computed(() => queryKeys.HARDWARE.HISTORY(projectId.value))

  const queryFn = async () => {
    return await getHardwareHistory(projectId.value)
  }

  return useQuery({
    queryFn,
    queryKey: queryKey.value,
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: () => !!projectId.value,
  })
}

export type UseHardwareHistoryData = ReturnType<typeof useHardwareHistory>['data']['value']
export type UseHardwareHistoryItem = NonNullable<UseHardwareHistoryData>['data']['history'][number]
export type UserHardwareHistoryEquipment = NonNullable<UseHardwareHistoryItem>['current_hardware_state']['inverters']
  | NonNullable<UseHardwareHistoryItem>['current_hardware_state']['microinverters']
  | NonNullable<UseHardwareHistoryItem>['current_hardware_state']['modules']
